import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface WorkflowExecutionConfig {
  showStatusFilter?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class WorkflowExecutionConfigService {
  private _config = new BehaviorSubject<WorkflowExecutionConfig>({
    showStatusFilter: false,
  });

  config$ = this._config.asObservable();

  get config(): WorkflowExecutionConfig {
    return this._config.value;
  }

  setConfig(config: WorkflowExecutionConfig): void {
    this._config.next({ ...this._config.value, ...config });
  }

  showStatusFilter(): void {
    this.setConfig({ showStatusFilter: true });
  }

  hideStatusFilter(): void {
    this.setConfig({ showStatusFilter: false });
  }
}
